import { FormattedMessage } from 'react-intl';

interface Props {
  email: string;
  originName: string;
  originCode: string;
  destinationName: string;
  destinationCode: string;
}

export default function AccountSummaryCard({
  email,
  originName,
  originCode,
  destinationName,
  destinationCode,
}: Props) {
  return (
    <dl className="grid gap-4 rounded-2xl border border-slate-100 bg-white/80 p-4 text-sm text-slate-500 sm:grid-cols-3">
      <div>
        <dt className="text-[0.65rem] uppercase tracking-[0.3em] text-slate-400">
          <FormattedMessage id="accounts.create.confirmation.emailLabel" />
        </dt>
        <dd className="mt-1 text-base font-semibold text-slate-900">{email}</dd>
      </div>
      <div>
        <dt className="text-[0.65rem] uppercase tracking-[0.3em] text-slate-400">
          <FormattedMessage id="accounts.create.confirmation.originLabel" />
        </dt>
        <dd className="mt-1 text-base font-semibold text-slate-900">
          {originName}
          <span className="ml-1 text-xs uppercase tracking-[0.3em] text-slate-400">
            ({originCode})
          </span>
        </dd>
      </div>
      <div>
        <dt className="text-[0.65rem] uppercase tracking-[0.3em] text-slate-400">
          <FormattedMessage id="accounts.create.confirmation.destinationLabel" />
        </dt>
        <dd className="mt-1 text-base font-semibold text-slate-900">
          {destinationName}
          <span className="ml-1 text-xs uppercase tracking-[0.3em] text-slate-400">
            ({destinationCode})
          </span>
        </dd>
      </div>
    </dl>
  );
}
